import { BarraFiltrosGlobales } from '@/components/filtros';
import { FiltrosGlobalesProvider } from '@/lib/FiltrosGlobalesContext';
import { Outlet } from 'react-router-dom';
import { HeaderAdelante } from './HeaderAdelante';

/**
 * Layout principal de la app: header oscuro + barra de filtros globales
 * + área de contenido light.
 *
 * Todos los hijos comparten el estado de filtros via FiltrosGlobalesContext.
 */
export function LayoutPrincipal() {
  return (
    <FiltrosGlobalesProvider>
      <div className="min-h-screen bg-zinc-50 text-foreground">
        <HeaderAdelante />
        <BarraFiltrosGlobales />
        <main className="container mx-auto max-w-7xl px-6 py-8">
          <Outlet />
        </main>
      </div>
    </FiltrosGlobalesProvider>
  );
}
